/**
 * Aliases from old TZ IANA names (which old browsers return) to new one, supported on BE side
 */
export const TIME_ZONE_ALIASES: Readonly<Record<string, string>> = {
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Europe/Kiev': 'Europe/Kyiv',
};
